import script from "./ClientProjectsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientProjectsTable.vue?vue&type=script&setup=true&lang=js"

import "./ClientProjectsTable.vue?vue&type=style&index=0&id=7db80e9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7db80e9c"]])

export default __exports__